"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HeaderTab_1 = __importDefault(require("@/components/HeaderTab"));
function EvaluatorsHeadersTabView({ tabs, onChangeTab, currentTab, isLoading }) {
    return (react_1.default.createElement(HeaderTab_1.default, { title: "Evaluators", options: tabs, isLoading: isLoading, onChangeTab: onChangeTab, currentTab: currentTab }));
}
exports.default = EvaluatorsHeadersTabView;
